module.exports = __webpack_public_path__ + "static/media/fountain.d8d0e5c9.png";